import { useState, useEffect } from "react";
import "./newCart.scss";
import { Button } from "@mui/material";
import { useOrder } from "../../../context/OrderContext";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { useNavigate } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import axios from "axios";
import { loadStripe } from "@stripe/stripe-js";
import { FormControlLabel, Checkbox, Alert } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import IconButton from "@mui/material/IconButton";
import moment from "moment";
import AffiliateData from "../Affiliate/affiliate.json";
import SeatingPlan from "../../images/seatingPlan.webp";
import { useSearchParams } from "react-router-dom";
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from "@stripe/react-stripe-js";
// const stripePromise = loadStripe("pk_test_HGDc5rMpzlE4NJvFygwF1zIW");
const stripePromise = await loadStripe("pk_live_aRr3qYrpVTbyNgBbB7t0jqiy");

export default function NewCart() {
  const [searchParams] = useSearchParams();
  const affiliateId = searchParams.get("affiliateId");
  // const url = "http://localhost:4100";
  const url = "https://dev.pmwevents.com";
  const { order, addToOrder, removeFromOrder, qtyAlert } = useOrder();
  const [ticketTypes, setTicketTypes] = useState([]);
  const navigate = useNavigate();
  const [options, setOptions] = useState({});
  const [showPayment, setShowPayment] = useState(false);
  const [formData, setFormData] = useState([]);
  const [errors, setErrors] = useState([]);
  const [tncs, setTncs] = useState(false);
  const [affiliate, setAffiliate] = useState(null);
  const [isAffiliate, setIsAffiliate] = useState(false);
  // alerts
  const [message, setMessage] = useState("");
  const [alert, setAlert] = useState(false);
  const [disable, setDisable] = useState(false);
  //AFFILIATE CHECK
  useEffect(() => {
    let found = false;

    for (let a = 0; a < AffiliateData.length; a++) {
      if (affiliateId === AffiliateData[a].id) {
        setAffiliate(AffiliateData[a]);

        found = true;
        break;
      }
    }
    setIsAffiliate(found);
  }, [affiliateId, navigate]);

  useEffect(() => {
    let _ticketTypes = JSON.parse(localStorage.getItem("ticketTypes"));
    setTicketTypes(_ticketTypes);
  }, []);

  const handleAlert = (message, duration = 3000) => {
    setDisable(true);
    setMessage(message);
    setAlert(true);
    setTimeout(() => {
      setAlert(false);
      setMessage("");
      setDisable(false);
    }, duration);
  };

  const handleInputChange = (
    e,
    oIndex,
    idx,
    field,
    ticketId,
    price,
    ticketType
  ) => {
    const updatedData = [...formData];
    if (!updatedData[oIndex]) updatedData[oIndex] = [];
    updatedData[oIndex][idx] = {
      ...updatedData[oIndex][idx],
      [field]: e.target.value,
      ticketId: ticketId,
      paidAmount: parseFloat((price * 1.2).toFixed(2)),
      ticketType: ticketType,
    };
    setFormData(updatedData);
  };

  const validateField = (field, value) => {
    switch (field) {
      case "email":
        return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)
          ? ""
          : "Please enter a valid email address.";
      case "phone":
        return /^(?:\+44|0)7\d{9}$|^(?:\+44|0)1\d{10}$|^(?:\+44|0)2\d{10}$/.test(
          value
        )
          ? ""
          : "Please enter a valid phone number (e.g., +44 7123 456789).";
      case "postcode":
        return /^[A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2}$/i.test(value)
          ? ""
          : "Please enter a valid postcode (e.g., SW1A 1AA).";
      default:
        return value ? "" : `Please enter your ${field}.`;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = [];
    setErrors([]);
    formData.forEach((oData, oIndex) => {
      oData.forEach((attendee, idx) => {
        const attendeeErrors = {};
        ["name", "lastName", "email", "phone", "address", "postcode"].forEach(
          (field) => {
            const error = validateField(field, attendee[field]);
            if (error) {
              attendeeErrors[field] = error;
            }
          }
        );
        if (Object.keys(attendeeErrors).length > 0) {
          newErrors[oIndex] = newErrors[oIndex] || [];
          newErrors[oIndex][idx] = attendeeErrors;
        }
      });
    });

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else if (!tncs) {
      handleAlert("Please check terms & conditions");
    } else {
      setErrors([]);
      handleSecret();
    }
  };

  const handleSecret = async () => {
    const compId = localStorage.getItem("compId");
    const competitionId = compId ? Number(compId) : null;

    let eventId = localStorage.getItem("eventId");
    let formattedOrder = order.map((o, i) => {
      return {
        price: o.priceId,
        quantity: o.qty,
      };
    });

    let formattedAttendees = formData.flat();

    formattedAttendees = formattedAttendees.map((a, i) => {
      let attendeeId = `${eventId}-${a.ticketId}-${moment().format(
        "DD-MM-YYYY"
      )}-${Math.floor(1000 + Math.random() * 9000)}`;
      return {
        ...a,
        eventId: eventId,
        attendeeId: attendeeId,
      };
    });

    let reqBody = {
      order: formattedOrder,
      attendees: formattedAttendees,
      discountCode: affiliateId ? affiliate?.discountCode : null,
      affiliateId: affiliateId ? affiliateId : null,
      ...(competitionId ? { competitionId: competitionId } : {}),
    };

    await axios
      .post(`${url}/sbc/new-secret`, reqBody)
      .then((res) => {
        setOptions({ clientSecret: res.data.clientSecret });
        setShowPayment(true);
        localStorage.removeItem("compId");
        window.scrollTo(0, 0);
      })
      .catch((err) => {
        console.log(err);
        if (err.response.data.message) {
          handleAlert(err.response.data.message);
        } else {
          handleAlert("Something went wrong - Contact support");
        }
      });
  };

  const isTicketInOrder = (ticketName) => {
    return order.some((item) => item.name === ticketName);
  };

  return (
    <main className="new-cart">
      {!showPayment ? (
        <>
          <section className="cart-add-more">
            {ticketTypes.length > 0
              ? ticketTypes.map((t, i) => {
                  let back = "";
                  if (t.name === "Elite") {
                    back = "#ff4840";
                  } else if (t.name === "VIP") {
                    back = "#226879";
                  } else {
                    back = "#1b505a";
                  }
                  return (
                    <div
                      className="ticket-card"
                      style={{ backgroundColor: back }}
                      key={i}
                    >
                      <h5>{t.name}</h5>

                      {isAffiliate ? (
                        <>
                          <h5
                            style={{
                              textDecoration: "line-through",
                              color: "#db2a2aff",
                              fontSize: "1.95em",
                              fontWeight: 500,
                            }}
                          >
                            £{t.price}
                          </h5>

                          <h5>
                            £
                            {(t.price * affiliate.discountPercentage).toFixed(
                              2
                            )}
                          </h5>
                        </>
                      ) : (
                        <h5>£{t.price}</h5>
                      )}

                      <h6>Plus VAT</h6>
                      <div className="bottom-section">
                        {t.percentageSold === 100 ? (
                          <p>SOLD OUT</p>
                        ) : isTicketInOrder(t.name) ? (
                          <IconButton onClick={() => removeFromOrder(t, true)}>
                            <CheckCircleIcon
                              fontSize="large"
                              className="icon-button"
                            />
                          </IconButton>
                        ) : (
                          <IconButton
                            onClick={() => addToOrder(t)}
                            disabled={isTicketInOrder(t.name)}
                          >
                            <RadioButtonUncheckedIcon
                              fontSize="large"
                              className="icon-button"
                            />
                          </IconButton>
                        )}
                      </div>
                    </div>
                  );
                })
              : null}
          </section>
          <img
            src={SeatingPlan}
            alt="SBC Seating Plan"
            className="sbc-seating-plan"
          />
          <section className="cart-order-items">
            <div>
              {order.length > 0 ? (
                <>
                  <h5>Total Payment</h5>
                  <hr />

                  <table className="cart-table">
                    <tbody>
                      {order.map((o, i) => {
                        return (
                          <tr key={i}>
                            <td>
                              <p className="ticket-type-name"> {o.name}</p>
                              {!isAffiliate ? (
                                <p className="price">
                                  £{o.price.toFixed(2)} + VAT
                                </p>
                              ) : (
                                <p className="price">
                                  £
                                  {(
                                    o.price.toFixed(2) *
                                    affiliate.discountPercentage
                                  ).toFixed(2)}{" "}
                                  + VAT
                                </p>
                              )}

                              <div class="cart-quantity-container">
                                <button
                                  class="qty-btn dec"
                                  onClick={() => {
                                    removeFromOrder(o);
                                  }}
                                >
                                  <RemoveIcon />
                                </button>
                                <span class="qty-display">{o.qty}</span>
                                <button
                                  class="qty-btn inc"
                                  onClick={() => addToOrder(o)}
                                  disabled={o.qty === 4}
                                >
                                  <AddIcon />
                                </button>
                              </div>
                            </td>
                            {!isAffiliate ? (
                              <td className="total-cell">
                                £{o.total.toFixed(2)} + <span>VAT</span>
                              </td>
                            ) : (
                              <td className="total-cell">
                                £
                                {(
                                  o.total.toFixed(2) *
                                  affiliate.discountPercentage
                                ).toFixed(2)}{" "}
                                + <span>VAT</span>
                              </td>
                            )}
                            {qtyAlert != "" ? (
                              <Alert
                                severity="warning"
                                style={{
                                  position: "absolute",
                                  top: "50%",
                                  left: "50%",
                                  width: "60%",
                                  transform: "translate(-50%, -50%)",
                                }}
                              >
                                No more {o.name} tickets available{" "}
                              </Alert>
                            ) : null}
                          </tr>
                        );
                      })}
                      <tr className="total-row">
                        <td>Total</td>
                        {!isAffiliate ? (
                          <td>
                            {" "}
                            £{order
                              .reduce((a, b) => a + b.total, 0)
                              .toFixed(2)}{" "}
                            + VAT
                          </td>
                        ) : (
                          <td>
                            {" "}
                            £
                            {(
                              order
                                .reduce((a, b) => a + b.total, 0)
                                .toFixed(2) * affiliate.discountPercentage
                            ).toFixed(2)}{" "}
                            + VAT
                          </td>
                        )}
                      </tr>
                    </tbody>
                  </table>
                </>
              ) : (
                <h4 className="empty-cart">
                  Looks like you don't have anything in your cart! Add more
                  above or click <span onClick={() => navigate("/")}>here</span>{" "}
                  to head back home.
                </h4>
              )}
            </div>
          </section>
          {order.length > 0 ? (
            <>
              <section className="attendee-forms">
                <h4>Please fill in details for all attendees</h4>
                <form onSubmit={handleSubmit}>
                  {order.map((o, i) => (
                    <div key={i}>
                      <h6 className="ticket-type">{o.name} Tickets</h6>
                      <div className="form-type-section">
                        {new Array(o.qty).fill(null).map((_, idx) => (
                          <div key={idx} className="contact-form">
                            <h5>
                              {o.name} Attendee {idx + 1}
                            </h5>
                            <div>
                              <label htmlFor={`name-${i}-${idx}`}>
                                First Name:
                              </label>
                              <input
                                type="text"
                                id={`name-${i}-${idx}`}
                                name="name"
                                placeholder="Fist Name"
                                required
                                onChange={(e) =>
                                  handleInputChange(
                                    e,
                                    i,
                                    idx,
                                    "name",
                                    o.typeId,
                                    o.price,
                                    o.name
                                  )
                                }
                              />
                              {errors[i] &&
                                errors[i][idx] &&
                                errors[i][idx].firstName && (
                                  <div className="error">
                                    {errors[i][idx].firstName}
                                  </div>
                                )}
                            </div>

                            <div>
                              <label htmlFor={`lastName-${i}-${idx}`}>
                                Last Name:
                              </label>
                              <input
                                type="text"
                                id={`lastName-${i}-${idx}`}
                                name="lastName"
                                placeholder="Last Name"
                                required
                                onChange={(e) =>
                                  handleInputChange(
                                    e,
                                    i,
                                    idx,
                                    "lastName",
                                    o.typeId,
                                    o.price,
                                    o.name
                                  )
                                }
                              />
                              {errors[i] &&
                                errors[i][idx] &&
                                errors[i][idx].lastName && (
                                  <div className="error">
                                    {errors[i][idx].lastName}
                                  </div>
                                )}
                            </div>

                            <div>
                              <label htmlFor={`email-${i}-${idx}`}>
                                Email:
                              </label>
                              <input
                                type="email"
                                id={`email-${i}-${idx}`}
                                name="email"
                                placeholder="Email"
                                required
                                onChange={(e) =>
                                  handleInputChange(
                                    e,
                                    i,
                                    idx,
                                    "email",
                                    o.typeId,
                                    o.price,
                                    o.name
                                  )
                                }
                              />
                              {errors[i] &&
                                errors[i][idx] &&
                                errors[i][idx].email && (
                                  <div className="error">
                                    {errors[i][idx].email}
                                  </div>
                                )}
                            </div>

                            <div>
                              <label htmlFor={`phone-${i}-${idx}`}>
                                Phone Number:
                              </label>
                              <input
                                type="text"
                                id={`phone-${i}-${idx}`}
                                name="phone"
                                placeholder="Phone Number"
                                required
                                onChange={(e) =>
                                  handleInputChange(
                                    e,
                                    i,
                                    idx,
                                    "phone",
                                    o.typeId,
                                    o.price,
                                    o.name
                                  )
                                }
                              />
                              {errors[i] &&
                                errors[i][idx] &&
                                errors[i][idx].phone && (
                                  <div className="error">
                                    {errors[i][idx].phone}
                                  </div>
                                )}
                            </div>

                            <div>
                              <label htmlFor={`address-${i}-${idx}`}>
                                Address:
                              </label>
                              <input
                                type="text"
                                id={`address-${i}-${idx}`}
                                name="address"
                                placeholder="Address"
                                required
                                onChange={(e) =>
                                  handleInputChange(
                                    e,
                                    i,
                                    idx,
                                    "address",
                                    o.typeId,
                                    o.price,
                                    o.name
                                  )
                                }
                              />
                              {errors[i] &&
                                errors[i][idx] &&
                                errors[i][idx].address && (
                                  <div className="error">
                                    {errors[i][idx].address}
                                  </div>
                                )}
                            </div>

                            <div>
                              <label htmlFor={`postcode-${i}-${idx}`}>
                                Postcode:
                              </label>
                              <input
                                type="text"
                                id={`postcode-${i}-${idx}`}
                                name="postcode"
                                placeholder="Postcode"
                                required
                                onChange={(e) =>
                                  handleInputChange(
                                    e,
                                    i,
                                    idx,
                                    "postcode",
                                    o.typeId,
                                    o.price,
                                    o.name
                                  )
                                }
                              />
                              {errors[i] &&
                                errors[i][idx] &&
                                errors[i][idx].postcode && (
                                  <div className="error">
                                    {errors[i][idx].postcode}
                                  </div>
                                )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}

                  <div className="payment-terms">
                    <FormControlLabel
                      control={<Checkbox />}
                      label="I confirm I have read and agree to the terms & conditions"
                      onChange={() => setTncs(!tncs)}
                    />
                    {alert ? <p>{message}</p> : null}
                    <Button
                      type="submit"
                      variant="outlined"
                      endIcon={<ArrowForwardIcon />}
                      className="to-payment-btn"
                      disabled={disable}
                    >
                      Continue to Payment
                    </Button>
                  </div>
                </form>
              </section>
            </>
          ) : null}
        </>
      ) : (
        <div className="payment-portal" style={{ marginTop: "5vh" }}>
          <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
            <EmbeddedCheckout />
          </EmbeddedCheckoutProvider>
        </div>
      )}
    </main>
  );
}
